<div class="ni-app">
  <header class="ni-titlebar">
    <span class="ni-logo">the new internet</span>
    <span class="ni-tagline">your corner of the web</span>
  </header>

  <nav class="ni-tabs">
    <button [class.active]="tab === 'stream'" (click)="setTab('stream')">
      Stream <span class="ni-badge" *ngIf="unreadCount">{{ unreadCount }}</span>
    </button>
    <button [class.active]="tab === 'library'" (click)="setTab('library')">Library</button>
    <button [class.active]="tab === 'history'" (click)="setTab('history')">History</button>
    <button [class.active]="tab === 'feeds'" (click)="setTab('feeds')">Feeds</button>
    <input class="ni-search" type="text" placeholder="search&hellip;" [(ngModel)]="search">
  </nav>

  <main class="ni-body">
    <p class="ni-loading" *ngIf="loading">Loading&hellip;</p>

    <app-ni-stream *ngIf="!loading && tab === 'stream'"
      [items]="feedItems"
      [errors]="feedErrors"
      [loading]="streamLoading"
      [search]="search"
      (open)="onOpenItem($event)"
      (toggleLike)="onToggleLike($event)"></app-ni-stream>
    <app-ni-library *ngIf="!loading && tab === 'library'"
      [likes]="likes"
      [categories]="categories"
      [readHashes]="readHashes"
      [search]="search"
      (open)="onOpenLike($event)"
      (recategorize)="openPicker($event)"
      (unlike)="onUnlike($event)"></app-ni-library>
    <app-ni-history *ngIf="!loading && tab === 'history'"
      [history]="history"
      [search]="search"></app-ni-history>
    <app-ni-subscriptions *ngIf="!loading && tab === 'feeds'"
      [subscriptions]="subscriptions"
      [errors]="feedErrors"
      [unreadByFeed]="unreadByFeed"
      (add)="onAddSubscription($event)"
      (remove)="onRemoveSubscription($event)"></app-ni-subscriptions>
  </main>

  <!-- category picker overlay -->
  <div class="ni-picker-backdrop" *ngIf="pickerLike" (click)="closePicker()">
    <div class="ni-picker" (click)="$event.stopPropagation()">
      <h3>File &ldquo;{{ pickerLike.title }}&rdquo;</h3>
      <div class="ni-picker-cats">
        <button *ngFor="let c of categories" (click)="chooseExisting(c.name)">{{ c.name }}</button>
        <span class="ni-picker-empty" *ngIf="categories.length === 0">No categories yet.</span>
      </div>
      <div class="ni-picker-new">
        <input type="text" placeholder="new category&hellip;" [(ngModel)]="newCategoryName"
               (keyup.enter)="createAndChoose()">
        <button (click)="createAndChoose()">Add</button>
      </div>
      <button class="ni-picker-skip" (click)="closePicker()">Skip &mdash; leave uncategorized</button>
    </div>
  </div>
</div>
